import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class UserID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
